import {DB_COLLECTION_NAMES} from "constants/AppConstants.js";
import {
  AppDataCollection,
  EquipCollection,
  GarminDataCollection,
  GarminManualUpdatesCollection,
  LogCollection,
  NavCollection,
  PointCollection,
  SharedDataCollection,
  StrokesCollection,
  SuuntoDataCollection,
  CorosDataCollection,
  UserCollection,
  WaitingApprovalActivitiesCollection
} from "services/FirebaseDbService.js";

export type DbCollection =
  | AppDataCollection
  | EquipCollection
  | GarminDataCollection
  | GarminManualUpdatesCollection
  | LogCollection
  | NavCollection
  | PointCollection
  | SharedDataCollection
  | StrokesCollection
  | SuuntoDataCollection
  | CorosDataCollection
  | UserCollection
  | WaitingApprovalActivitiesCollection;

export class DbCollectionFactory {
  static create(collectionName: string): DbCollection {
    switch (collectionName) {
      case DB_COLLECTION_NAMES.users:
        return new UserCollection();
      case DB_COLLECTION_NAMES.navs:
        return new NavCollection();
      case DB_COLLECTION_NAMES.points:
        return new PointCollection();
      case DB_COLLECTION_NAMES.logs:
        return new LogCollection();
      case DB_COLLECTION_NAMES.equip:
        return new EquipCollection();
      case DB_COLLECTION_NAMES.appData:
        return new AppDataCollection();
      case DB_COLLECTION_NAMES.sharedData:
        return new SharedDataCollection();
      case DB_COLLECTION_NAMES.garminData:
        return new GarminDataCollection();
      case DB_COLLECTION_NAMES.garminManualUpdates:
        return new GarminManualUpdatesCollection();
      case DB_COLLECTION_NAMES.strokes:
        return new StrokesCollection();
      case DB_COLLECTION_NAMES.suuntoData:
        return new SuuntoDataCollection();
      case DB_COLLECTION_NAMES.corosData:
        return new CorosDataCollection();
      case DB_COLLECTION_NAMES.waitingApprovalActivities:
        return new WaitingApprovalActivitiesCollection();
      default:
        throw new Error(`invalid collection name: ${collectionName}`);
    }
  }
}
